module.exports = {"testing":"HI"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 795
// module chunks = 2